import {Component, OnInit} from '@angular/core';
import {BaseComponent} from '../../core/base.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {AccountService} from '../account.service';
import {UserProfile} from '../../api/models/user-profile';
import {RouterHelper} from '../../core/utilities/router-helper';
import {AuthService} from '../../core/security/auth.service';
import {NotificationService} from '../../notification/notification.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {LocalNotificationsService} from '../../core/services/local-notifications.service';
import {UserDeviceModel} from '../../api/models/user-device-model';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import {NotificationModel} from '../../api/models/notification-model';
import {MatConfirmDialogComponent} from '../../dialogs/mat-confirm/mat-confirm-dialog.component';
import {UsersComponent} from '../users/users.component';
import {MatDialog} from '@angular/material/dialog';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { NgIf } from '@angular/common';
import { MatAnchor, MatButton, MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { MatIcon } from '@angular/material/icon';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';
import { YesNoPipe } from '../../core/pipes/yesno.pipe';

@Component({
    selector: 'app-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
    standalone: true,
    imports: [
        MatCard,
        MatCardTitle,
        MatCardContent,
        MatCardActions,
        NgIf,
        MatAnchor,
        MatTooltip,
        RouterLink,
        MatButton,
        Angular2PromiseButtonModule,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatIconButton,
        MatIcon,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        PhoneNumberPipe,
        DateTimePipe,
        YesNoPipe,
    ],
})
export class ProfileComponent extends BaseComponent implements OnInit {

  profileModel: UserProfile = {
    username: null,
    email: null,
    settings: {}
  };
  editProfileUrl: string;
  buttonSubmitPromise: Promise<void>;

  displayedColumns: string[] = ['appName', 'deviceModel', 'isPushEnabled', 'actions'];
  hasDevices = false;
  dataSource = new MatTableDataSource<UserDeviceModel>([]);

  constructor(route: ActivatedRoute, titleService: Title, headerService: HeaderService,  authService: AuthService,
              public dialog: MatDialog,
              private accountService: AccountService,
              private notificationService: NotificationService,
              private notificationsService: LocalNotificationsService,
  ) {
    super(route, headerService, titleService, authService);

    this.headerService.showBackButton(false);

    this.editRoles = [RolesEnum.AccountProfile_Edit];

    const profileModule = RouterHelper.getRouteByComponent('ProfileEditComponent');
    this.editProfileUrl = this.headerService.themePrefix + profileModule.path;
  }

  async ngOnInit() {
    super.ngOnInit();

    this.profileModel = await this.accountService.getUserProfile();

    await this.getUserDevice();
  }

  async getUserDevice() {
    this.dataSource.data = await this.accountService.getUserDevices();

    this.hasDevices = this.dataSource.data && this.dataSource.data.length > 0
  }

  onUnsubscribe() {
      this.buttonSubmitPromise = this.processUnsubscribe();
  }

  async processUnsubscribe(): Promise<void> {
    if (await this.notificationsService.unsubscribeNotifications()) {
      this.notificationService.notifySuccess('You have successfully unsubscribed');
    }
  }

  onDeleteDeviceConfirm($event: MouseEvent, device: UserDeviceModel) {
    const dialogRef = this.dialog.open(MatConfirmDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Device?',
        text: 'Are you sure you want to delete device?',
        actionTitle: 'Delete',
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.accountService.deleteUserDevice(device.id);
        await this.getUserDevice();
        await this.notificationService.notifySuccess('Device deleted successfully');
      }
    });
  }
}
